/* eslint-disable react/prop-types */
import React from 'react';
// eslint-disable-next-line no-unused-vars
import { Box, Grid } from '@material-ui/core';
import { motion } from 'framer-motion';
import ColorButtonPurple from './ColorButtonPurple.js';
import ColorButtonWhite from './ColorButtonWhite.js';
import CopyRight from './CopyRight.js';
import { Link } from 'react-router-dom';

class Step1 extends React.Component {
  render() {
    return (
      <div>
        <motion.div
          className="contents-inner"
          animate={{
            x: 0,
            opacity: 1,
          }}
          initial={{
            x: 100,
            opacity: 0,
          }}
          exit={{
            x: -100,
            opacity: 0,
          }}
          transition={{
            duration: 0.2,
          }}
        >
          <Box marginTop={5} marginBottom={5}>
            <h2 className="question">ありがとうございました。</h2>
            <h2 className="question">Place Simulatorへ</h2>
          </Box>

          <Grid container direction="column">
            <Grid item>
              <Box m={1}>
                <a className="menu-link" href="https://workpath.co.jp/simulator/" target="blank">
                  <ColorButtonPurple size="large" variant="outlined">
                    有料版へ
                  </ColorButtonPurple>
                </a>
              </Box>
            </Grid>
            <Grid item>
              <Box m={2}>
                <ColorButtonWhite size="large" variant="outlined" component={Link} to="/">
                  最初から
                </ColorButtonWhite>
              </Box>
            </Grid>
          </Grid>
          <Box marginTop={15}>
            <CopyRight />
          </Box>
        </motion.div>
      </div>
    );
  }
}

export default Step1;
